var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProperties(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONOS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.4626 8.7771H24.0015V9.70152H26.4626V8.7771Z",
    fill: "#f15b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1542 17.797H11.6931V20.2581H14.1542V17.797Z",
    fill: "#f15b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.23207 17.797H6.771V20.2581H9.23207V17.797Z",
    fill: "#f15b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16 0.469482C7.16499 0.469482 0 7.63448 0 16.4695C0 25.3045 7.16499 32.4695 16 32.4695C24.835 32.4695 32 25.3045 32 16.4695C32 7.63448 24.838 0.469482 16 0.469482ZM16 1.70002C24.1561 1.70002 30.7695 8.31339 30.7695 16.4695C30.7695 18.6638 30.2906 20.7461 29.4328 22.6191H26.4656V10.3107H23.9955V11.8959L21.1798 9.0802H9.60485L4.30385 14.3812V22.6191H2.57018C1.71245 20.7461 1.23357 18.6638 1.23357 16.4695C1.23054 8.31339 7.84391 1.70002 16 1.70002ZM19.6916 17.8819V22.6191H16.6183V14.8934L20.9221 10.5775L24.1773 13.8326L25.226 14.8934V22.6191H22.974V17.8819H19.6916ZM5.54044 15.2571H15.3787V22.6191H5.54347V15.2571H5.54044ZM15.997 31.2389C10.5323 31.2389 5.7617 28.2717 3.20667 23.8588H28.7873C26.2322 28.2717 21.4616 31.2389 15.997 31.2389Z",
    fill: "#f15b2b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperties);
export default __webpack_public_path__ + "static/media/properties.e0561b7d3b3572c2e63cbedc164207c4.svg";
export { ForwardRef as ReactComponent };